import { Component, Input, OnInit, Injector } from '@angular/core';
import { ILoginForm } from '../../forms/login-form/login-form.component';
import { AuthService } from '../../services/auth.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ModalController, NavParams } from '@ionic/angular';
import { SettingService } from 'src/app/shared/services/setting.service';
import { ForgotPasswordPageComponent } from '../forgot-password-page/forgot-password-page.component';

@Component({
    selector: 'app-login-page',
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.scss'],
    standalone: false
})
export class LoginPageComponent implements OnInit {
  title: string = "Nav.Login";
  @Input() fromDesktopCheckout: boolean = false;

  disableHeader: boolean = false;
  isPopup: boolean = false;
  mobile: boolean = false;

  constructor(private route: ActivatedRoute,private router: Router,
    private modalCtrl: ModalController,
    public setting: SettingService,
    private injector: Injector,
    private authService: AuthService) { }

  ngOnInit() {
    const navParams = this.injector.get(NavParams, null);

    try {
      if(navParams.get('disableHeader') != undefined) {
        this.disableHeader = navParams.get('disableHeader');
        this.isPopup = true;
      }
    } catch (e) {

    }

    if(this.isPopup) {
      if (window.innerWidth <= 600) {
        this.mobile = true;
  
        this.disableHeader = false;
      } else {
        this.mobile = false;
  
        this.disableHeader = true;
      }
    }

    if(!this.fromDesktopCheckout) {
      const language = this.route.snapshot.paramMap.get('language');
      if(language)
      {
        if(language === 'en' || language ==='fr')
        { }
        else {
          this.router.navigate(['/auth'])
        }
      }
    }

  }

  async onLogin() {
    if(this.fromDesktopCheckout){
      this.modalCtrl.dismiss({
        onLogin: true
      });

      /*
      this.modalCtrl.dismiss({
        onLogin: true
      });
      */
    } else {
      if(this.setting.configuration.uIoptions?.loginToPopup) {
        this.closePopup();    
      } else {
        this.modalCtrl.dismiss({
          onLogin: true
        });
      }
    }
  }

  async onForgotPasswordClicked() {
    if(this.fromDesktopCheckout){
      if(this.setting.configuration.uIoptions?.loginToPopup) {
        this.closePopup();    

        // prevents crash if the undocked navbar is inside a popup
        const modal = await this.modalCtrl.create({
          component: ForgotPasswordPageComponent,
          cssClass: 'passForgot-popup-model',
          componentProps: {
            disableHeader: false
          }
        });
      
        modal.onWillDismiss()
          .then((result) => {
            
        });
      
        await modal.present();
      } else {
        this.router.navigateByUrl('/auth/forgot-password');
        this.modalCtrl.dismiss({
          onForgotPasswordClicked: true
        });
      }
    } else {
      if(this.setting.configuration.uIoptions?.loginToPopup) {
        this.closePopup();    

        // prevents crash if the undocked navbar is inside a popup
        const modal = await this.modalCtrl.create({
          component: ForgotPasswordPageComponent,
          cssClass: 'passForgot-popup-model',
          componentProps: {
            disableHeader: false
          }
        });
      
        modal.onWillDismiss()
          .then((result) => {
            
        });
      
        await modal.present();
      } else {
        this.router.navigateByUrl('/auth/forgot-password');
        this.modalCtrl.dismiss({
          onForgotPasswordClicked: true
        });
      }
    }

    //this.router.navigateByUrl('/auth/forgot-password');
      /*
      this.modalCtrl.dismiss({
        onForgotPasswordClicked: true
      });
      */

      
  }

  closePopup(){
    if(this.isPopup) {
      this.modalCtrl.dismiss();
    }
  }
}
